import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { useAuth } from "@/components/AuthProvider";

export const useHouses = () => {
  const { toast } = useToast();
  const { user } = useAuth();

  // Check if user is admin
  const { data: isAdmin = false } = useQuery({
    queryKey: ['user-role-admin'],
    queryFn: async () => {
      if (!user) return false;
      
      const { data: hasRole, error } = await supabase.rpc('has_role', {
        _role: 'admin'
      });

      if (error) {
        console.error('Error checking admin role:', error);
        return false;
      }

      return hasRole;
    },
    enabled: !!user,
  });

  // Fetch houses based on user role
  const { data: houses = [] } = useQuery({
    queryKey: ['houses', isAdmin, user?.id],
    queryFn: async () => {
      if (!user) return [];
      
      let query;
      
      if (isAdmin) {
        // If admin, fetch all houses
        query = supabase
          .from('houses')
          .select('id, name');
      } else {
        // If not admin, only fetch houses where user is a member
        query = supabase
          .from('house_members')
          .select(`
            house:houses(id, name)
          `)
          .eq('user_id', user.id);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching houses:', error);
        toast({
          title: "Error",
          description: "No se pudieron cargar las casas",
          variant: "destructive",
        });
        throw error;
      }

      // If not admin, we need to map the data to match the expected format
      if (!isAdmin && data) {
        return data.map(item => ({
          id: item.house.id,
          name: item.house.name
        }));
      }

      return data || [];
    },
    enabled: !!user && isAdmin !== undefined,
  });

  return { houses };
};